import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MaterialModule } from '../../material/material.module';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-dialog-terms',
    standalone: true,
    imports: [MaterialModule, CommonModule],
    template: `
    <div class="dialog-container">
      <mat-dialog-content class="dialog-content">
        <div class="terms-header">
          <div class="header-content">
            <div class="logo-section">
              <img src="/assets/Hubmedical_logo_PNG.png" alt="HubMedical" class="logo" width="120" height="36">
            </div>
            <div class="version-info">
              <p class="version">Versão 1.0</p>
              <p class="publish-date">Publicado em Dezembro 2025</p>
            </div>
          </div>
        </div>

        <!-- Table of Contents -->
        <nav class="toc" role="navigation" aria-label="Índice dos termos de uso">
          <h2 class="toc-title">Índice</h2>
          <ol class="toc-list">
            <li><a href="#objetivo" (click)="scrollToSection('objetivo', $event)">Objetivo da Plataforma</a></li>
            <li><a href="#aceitacao" (click)="scrollToSection('aceitacao', $event)">Aceitação dos Termos</a></li>
            <li><a href="#cadastro" (click)="scrollToSection('cadastro', $event)">Cadastro e Elegibilidade</a></li>
            <li><a href="#verificacao" (click)="scrollToSection('verificacao', $event)">Verificação e Validação de Documentos</a></li>
            <li><a href="#compartilhamento" (click)="scrollToSection('compartilhamento', $event)">Compartilhamento de Informações</a></li>
            <li><a href="#responsabilidade" (click)="scrollToSection('responsabilidade', $event)">Responsabilidade dos Usuários</a></li>
            <li><a href="#comunicacao" (click)="scrollToSection('comunicacao', $event)">Comunicação entre Usuários</a></li>
            <li><a href="#gratuidade" (click)="scrollToSection('gratuidade', $event)">Gratuidade e Planos</a></li>
            <li><a href="#privacidade" (click)="scrollToSection('privacidade', $event)">Privacidade e Proteção de Dados</a></li>
            <li><a href="#propriedade" (click)="scrollToSection('propriedade', $event)">Propriedade Intelectual</a></li>
            <li><a href="#alteracoes" (click)="scrollToSection('alteracoes', $event)">Alterações nas Regras</a></li>
          </ol>
        </nav>

        <div class="terms-content">
          <div class="title-section">
            <h1 class="main-title">Regras de Uso – HubMedical</h1>
            <div class="download-section">
              <button mat-raised-button 
                      color="primary" 
                      class="download-btn"
                      (click)="downloadPDF()"
                      aria-label="Baixar PDF dos termos de uso">
                <mat-icon>download</mat-icon>
                Baixar PDF
              </button>
            </div>
          </div>
          
          <!-- Section 1 -->
          <section id="objetivo" class="terms-section">
            <h2>1. Objetivo da Plataforma</h2>
            <p>A HubMedical é uma plataforma digital voltada exclusivamente para o setor da saúde no Brasil. Seu propósito é conectar profissionais da saúde, estabelecimentos e contratantes de serviços por meio de um sistema seguro, transparente e validado documentalmente.</p>
          </section>

          <!-- Section 2 -->
          <section id="aceitacao" class="terms-section">
            <h2>2. Aceitação dos Termos</h2>
            <p>Ao acessar ou utilizar a HubMedical, o usuário declara estar ciente e de acordo com estas Regras de Uso, bem como com a Política de Privacidade e demais documentos legais da plataforma.</p>
          </section>

          <!-- Section 3 -->
          <section id="cadastro" class="terms-section">
            <h2>3. Cadastro e Elegibilidade</h2>
            <ul>
              <li>Apenas profissionais da saúde registrados em conselhos regionais e estabelecimentos cadastrados no CNES podem se registrar.</li>
              <li>É obrigatório fornecer informações verdadeiras e manter os dados atualizados.</li>
              <li>O usuário é responsável pela confidencialidade de suas credenciais de acesso.</li>
            </ul>
          </section>

          <!-- Section 4 -->
          <section id="verificacao" class="terms-section">
            <h2>4. Verificação e Validação de Documentos</h2>
            <ul>
              <li>Todos os documentos são verificados junto aos órgãos competentes para garantir autenticidade.</li>
              <li>O usuário deve manter seus documentos válidos e atualizados.</li>
              <li>A plataforma emite alertas sobre vencimento de documentos, mas o usuário permanece responsável por manter seus dados atualizados.</li>
            </ul>
          </section>

          <!-- Section 5 -->
          <section id="compartilhamento" class="terms-section">
            <h2>5. Compartilhamento de Informações</h2>
            <ul>
              <li>O usuário pode compartilhar documentos com outros perfis dentro da plataforma, respeitando os limites de privacidade e segurança.</li>
              <li>O compartilhamento é voluntário e deve seguir os princípios de boa-fé e finalidade legítima.</li>
            </ul>
          </section>

          <!-- Section 6 -->
          <section id="responsabilidade" class="terms-section">
            <h2>6. Responsabilidade dos Usuários</h2>
            <ul>
              <li>O usuário é integralmente responsável pelo uso adequado da plataforma.</li>
              <li>É vedado o uso da plataforma para finalidades ilegais, antiéticas ou prejudiciais a terceiros.</li>
              <li>Acordos, negociações e contratos firmados entre usuários são de responsabilidade exclusiva das partes envolvidas.</li>
            </ul>
          </section>

          <!-- Section 7 -->
          <section id="comunicacao" class="terms-section">
            <h2>7. Comunicação entre Usuários</h2>
            <ul>
              <li>A plataforma oferece canais seguros para comunicação entre usuários verificados.</li>
              <li>Toda comunicação deve ser respeitosa e profissional.</li>
              <li>A HubMedical poderá monitorar comunicações para garantir o cumprimento destas regras.</li>
            </ul>
          </section>

          <!-- Section 8 -->
          <section id="gratuidade" class="terms-section">
            <h2>8. Gratuidade e Planos</h2>
            <ul>
              <li>Durante a fase Beta, o uso da plataforma é gratuito.</li>
              <li>Após o lançamento oficial, os usuários terão direito a 30 dias gratuitos.</li>
              <li>Os planos serão anuais com pagamento mensal, conforme informado na seção de produtos.</li>
            </ul>
          </section>

          <!-- Section 9 -->
          <section id="privacidade" class="terms-section">
            <h2>9. Privacidade e Proteção de Dados</h2>
            <ul>
              <li>A HubMedical respeita a privacidade dos usuários e cumpre integralmente o Marco Civil da Internet e a Lei Geral de Proteção de Dados (LGPD).</li>
              <li>Os dados coletados são utilizados exclusivamente para fins operacionais da plataforma, conforme descrito na Política de Privacidade.</li>
            </ul>
          </section>

          <!-- Section 10 -->
          <section id="propriedade" class="terms-section">
            <h2>10. Propriedade Intelectual</h2>
            <p>Todo o conteúdo da plataforma, incluindo textos, imagens, ilustrações e funcionalidades, é protegido por direitos autorais e não pode ser reproduzido sem autorização expressa.</p>
          </section>

          <!-- Section 11 -->
          <section id="alteracoes" class="terms-section">
            <h2>11. Alterações nas Regras</h2>
            <p>A HubMedical poderá atualizar estas Regras de Uso a qualquer momento, mediante aviso prévio aos usuários. O uso contínuo da plataforma após alterações implica concordância com os novos termos.</p>
          </section>
        </div>
      </mat-dialog-content>

      <mat-dialog-actions align="end">
        <button mat-button (click)="close()">Fechar</button>
      </mat-dialog-actions>
    </div>
  `,
    styles: [`
    .dialog-container {
      max-width: 900px;
      background-color: #fff;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
    }

    .dialog-content {
      max-height: none !important;
      overflow-y: auto;
      padding: 0 !important;
      flex: 1;
    }

    .terms-header {
      border-bottom: 2px solid #e0e0e0;
      margin-bottom: 1.5rem;
      padding: 1rem 1.5rem 1rem;
      flex-shrink: 0;
    }

    .header-content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      gap: 1rem;
    }

    .logo {
      max-width: 120px;
      height: auto;
    }

    .version-info {
      text-align: right;
    }

    .version {
      font-weight: 600;
      color: #1976d2;
      margin-bottom: 0.25rem;
      font-size: 0.9rem;
    }

    .publish-date {
      color: #666;
      font-size: 0.8rem;
      margin: 0;
    }

    /* Table of Contents Styles */
    .toc {
      background: #f8f9fa;
      border: 1px solid #e9ecef;
      border-radius: 8px;
      padding: 1.5rem;
      margin: 0 1.5rem 1.5rem;
      flex-shrink: 0;
    }

    .toc-title {
      font-size: 1.2rem;
      font-weight: 600;
      color: #1976d2;
      margin-bottom: 1rem;
    }

    .toc-list {
      list-style: decimal;
      padding-left: 1.2rem;
    }

    .toc-list li {
      margin-bottom: 0.5rem;
    }

    .toc-list a {
      color: #1976d2;
      text-decoration: none;
      display: block;
      padding: 0.25rem 0;
      border-radius: 4px;
      transition: all 0.2s ease;
      cursor: pointer;
    }

    .toc-list a:hover, 
    .toc-list a:focus {
      background: #e3f2fd;
      text-decoration: underline;
      outline: 2px solid #1976d2;
      outline-offset: 2px;
    }

    .terms-content {
      padding: 0 1.5rem 1rem;
    }

    .title-section {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 1.5rem;
      flex-wrap: wrap;
      gap: 1rem;
    }

    .main-title {
      font-size: 1.5rem;
      font-weight: 700;
      color: #1976d2;
      margin: 0;
    }

    .download-section {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
    }

    .download-btn {
      display: inline-flex;
      align-items: center;
      gap: 0.5rem;
    }

    .terms-section {
      margin-bottom: 1.5rem;
      scroll-margin-top: 100px;
    }

    .terms-section h2 {
      font-size: 1.1rem;
      font-weight: 600;
      color: #1976d2;
      margin-bottom: 0.75rem;
      border-bottom: 1px solid #e3f2fd;
      padding-bottom: 0.25rem;
    }

    .terms-section p {
      margin-bottom: 0.75rem;
      line-height: 1.5;
      text-align: justify;
    }

    .terms-section ul {
      margin-bottom: 0.75rem;
      padding-left: 1.25rem;
    }

    .terms-section li {
      margin-bottom: 0.5rem;
      line-height: 1.5;
      text-align: justify;
    }

    @media (max-width: 768px) {
      .header-content {
        flex-direction: column;
        text-align: center;
      }

      .version-info {
        text-align: center;
      }

      .title-section {
        flex-direction: column;
        align-items: stretch;
      }

      .main-title {
        font-size: 1.25rem;
        text-align: center;
      }

      .terms-content {
        padding: 0 1rem 1rem;
      }

      .toc {
        margin: 0 1rem 1.5rem;
        padding: 1rem;
      }

      .toc-title {
        font-size: 1.1rem;
      }

      .terms-header {
        padding: 1rem;
      }
    }
  `]
})
export class DialogTermsComponent {
    constructor(
        public dialogRef: MatDialogRef<DialogTermsComponent>
    ) { }

    close(): void {
        this.dialogRef.close();
    }

    scrollToSection(sectionId: string, event: Event): void {
        event.preventDefault();
        const element = document.getElementById(sectionId);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }

    downloadPDF(): void {
        // Download direto do PDF já gerado
        const link = document.createElement('a');
        link.href = '/assets/docs/termos-uso.pdf';
        link.download = 'hubmedical-termos-de-uso.pdf';
        link.click();
    }
}